export default __webpack_public_path__ + "static/media/tiivii.013461fe.svg";